<template>
  <div class="" >
    <div v-if="eventLogoUrl" :class="{ 'w-[80px]': isSmall }">
      <figure>
        <img :src="eventLogoUrl" alt="Event logo image" class="w-full" />
      </figure>
    </div>
    <div v-else-if="!eventImage && showDefault"  :class="{ 'w-[76px]': isSmall }">
      <figure>
        <img src="@/assets/logo.png" alt="Event logo image" class="w-full" />
      </figure>
    </div>
    <div></div>
  </div>
</template>

<script setup lang="ts">
import useManageFile from "@/modules/useManageFile";
import { ref } from "vue";
const { getEventFile } = useManageFile();

const eventLogoUrl = ref();

const props = defineProps({
  eventId: String,
  eventImage: {
    type: String,
    default: null,
  },
  showDefault: {
    type: Boolean,
    default: true,
  },
  isSmall: {
    type: Boolean,
    required: true,
  },
});

const initialize = async () => {
  if (props.eventImage) {
    eventLogoUrl.value = await getEventFile(
      props.eventId as string,
      props.eventImage
    );
  }
};

initialize();
</script>